import React from 'react';
import PropTypes from 'prop-types';

import { LinearProgress } from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';

/**
 * A simple component for letting the user know that they are moving a unit
 */
const MovingUnitIndicator = ({
  unitCode,
  creditPoints,
  requiredCreditPoints,
}) => {
  // Place spaces between characters to force screen reader to read one character at a time
  const accessibleUnitCode = unitCode.split('').join(' ');

  return (
    <div style={{ margin: 0 }} className="flexcol">
      <div style={{ padding: '0.5em 1em' }} className="flexrow">
        <div className="flex-item-lg flexcol">
          <div className="flex-item-lg">
            <h3 className="heavy-text" style={{ margin: 0 }}>
              <div
                style={{
                  display: 'inline-flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <InfoIcon style={{ width: 16, height: 16 }} />{' '}
                <span style={{ marginLeft: '0.5em' }}>
                  Moving {unitCode || 'unit'}
                </span>
              </div>
            </h3>
          </div>
          <div className="flex-item-lg">
            <h5
              className="light-text"
              aria-live="polite"
              aria-label={
                'Drop ' +
                (accessibleUnitCode || 'it') +
                ', or on another unit to swap the units.'
              }
              style={{ margin: 0 }}>
              Drop the unit in an empty cell, or on another unit to swap the
              units.
            </h5>
          </div>
        </div>
        <div className="flex-item-sm flexcol">
          <div className="flex-item-sm">
            <p className="light-text" style={{ margin: 0 }}>
              {requiredCreditPoints
                ? `${creditPoints}/${requiredCreditPoints}`
                : `${creditPoints}`}
            </p>
          </div>
          <div className="flex-item-sm">
            <p className="light-text" style={{ margin: 0 }}>
              Credit Points
            </p>
          </div>
        </div>
        <div className="flex-item-sm">
          {/* Empty div for maintaining layout*/}
        </div>
      </div>
      <LinearProgress mode="indeterminate" />
    </div>
  );
};

export default MovingUnitIndicator;

MovingUnitIndicator.propTypes = {
  unitCode: PropTypes.string.isRequired,
  creditPoints: PropTypes.number,
  requiredCreditPoints: PropTypes.number,
};
